import { atDayStart } from './dateFormatters';
import shouldResetRangeSelection from './shouldResetRangeSelection';

export const usesOneWaySingleMode = ({ preserveTripType, modalTab, roundWithOpenSlot }) =>
  Boolean(preserveTripType) && modalTab === 'oneWay' && !roundWithOpenSlot;

// Once Round has a departure, show and fetch return availability even if
// the return date was prefilled by the system.
export const resolveCalendarPricingLeg = ({ modalTab, startDate, roundWithOpenSlot }) =>
  modalTab === 'round' && Boolean(startDate) && !roundWithOpenSlot ? 'return' : 'departure';

export const resolvePreserveTripRoundRangeChange = ({
  range,
  selectedDate,
  startDate,
  endDate,
  shouldResetSelection,
}) => {
  const clickedDate = atDayStart(selectedDate || range?.to || null);

  if (!range) {
    if (
      shouldResetRangeSelection({
        clickedDate,
        shouldResetSelection,
        startDate,
        endDate,
      })
    ) {
      return { type: 'reset', date: clickedDate };
    }

    if (startDate != null || endDate != null) {
      return { type: 'noop' };
    }

    return { type: 'clear' };
  }

  const start = atDayStart(range?.from || null);
  const rawEnd = atDayStart(range?.to || null);
  const end = rawEnd && start ? rawEnd : null;

  if (
    shouldResetRangeSelection({
      clickedDate,
      shouldResetSelection,
      startDate,
      endDate,
    })
  ) {
    return { type: 'reset', date: clickedDate };
  }

  if (start && end) {
    return { type: 'complete', start, end };
  }

  if (start && !end) {
    return { type: 'partial', start };
  }

  return { type: 'noop' };
};

export const resolveFooterTodayAction = ({ preserveTripType, modalTab }) => {
  if (preserveTripType && modalTab === 'round') {
    return { type: 'roundToday' };
  }

  return { type: 'oneWayToday' };
};
